module.exports = __webpack_public_path__ + "img/product-complaint-happen-bg-icon.01f11f24.png";